import {defineStore} from "pinia";

export const useListBookingsStore = defineStore('bookings', {
    state: () => ({
        searchFilters: {
            ref: null,
            agentRef: null,
            name: null,
            dateFrom: null,
            dateTo: null
        },
        pageFilters: {
            status: null
        },
        bookingsList: null,
        refreshNext: false,
        error: null
    }),
    getters:  {
        bookings: (state) => state.bookingsList,
    },
    actions: {
        async listBookings(refreshState) {
            this.error = null
            if (refreshState || this.refreshNext) {
                this.bookingsList = null;
                this.refreshNext = false;
            }

            if (!this.bookingsList) {
                try {
                    const response = await axios.post('/api/list-bookings', {
                        ref: this.searchFilters.ref,
                        agentRef: this.searchFilters.agentRef,
                        name: this.searchFilters.name,
                        dateFrom: this.searchFilters.dateFrom,
                        dateTo: this.searchFilters.dateTo
                    }, {
                        timeout: 20000 // Timeout 20 seconds
                    });
                    if (response.data.message) {
                        this.error = response.data;
                    } else {
                        this.bookingsList = response.data.ListBookingsReply.BookingHeaders;
                    }

                } catch (err) {
                    //this.error = err.response.data;
                    this.error = err.response?.data?.message || err.message || 'An unknown error occurred'
                }
            }
        },

        async resetSearchFilters() {
            this.bookingsList = null;
            this.error = null;

            this.searchFilters = {
                ref: null,
                agentRef: null,
                name: null,
                dateFrom: null,
                dateTo: null
            };

            this.pageFilters = {
                status: null
            };

            // Calculate start date (40 days ago)
            let startDate = new Date();
            startDate.setDate(startDate.getDate() - 20);
            this.searchFilters.dateFrom = startDate.toISOString().split('T')[0];

            // Calculate end date (40 days from now)
            let endDate = new Date();
            endDate.setDate(endDate.getDate() + 60);
            this.searchFilters.dateTo = endDate.toISOString().split('T')[0];

            // Trigger listBookings with updated filters
            this.listBookings(true);
        },

        async resetData() {
            this.bookingsList = null;
            this.error = null;

            this.searchFilters = {
                ref: null,
                agentRef: null,
                name: null,
                dateFrom: null,
                dateTo: null
            };

            this.pageFilters = {
                status: null
            };
        }
    }
})
